// DS2 Boolean Value: a yes / no, e.g. a list's flag column - a check circle for yes, a cross circle for no. highlight:
// the state that matters, at full opacity; the other one faded. colors: yes's and no's (any CSS colour; each one left
// out keeps the DS2 one, green and red). Read as "Yes" / "No" in the user's language.
import cx from "classnames";
import type { CSSProperties } from "react";
import useI18n from "../../hooks/useTranslations";
import { CheckCircleIcon, WrongIcon } from "./icons";
import styles from "./BooleanValue.module.css";

export type BooleanValueProps = {
  value: boolean;
  highlight?: "yes" | "no";
  colors?: { yes?: string; no?: string };
  className?: string;
};

export function BooleanValue({ value, highlight = "yes", colors, className }: BooleanValueProps) {
  const { yes, no } = useI18n().translation.common;
  const state = value ? "yes" : "no";
  const Icon = value ? CheckCircleIcon : WrongIcon;
  return (
    <Icon
      className={cx(styles.icon, styles[state], state !== highlight && styles.faded, className)}
      style={{ "--boolean-value-yes": colors?.yes, "--boolean-value-no": colors?.no } as CSSProperties}
      role="img"
      aria-hidden={false}
      aria-label={value ? yes : no}
    />
  );
}
